import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FilterSupplierCouponOptions, SupplierCouponApi } from 'api';

export const filterSupplierCoupon = createAsyncThunk(
  'supplierCoupon/filterSupplierCoupon',
  async (option: FilterSupplierCouponOptions, { rejectWithValue }) => {
    try {
      const response = await SupplierCouponApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findSupplierCouponForTableList = createAsyncThunk(
  'supplierCoupon/findSupplierCouponForTableList',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await SupplierCouponApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createSupplierCoupon = createAsyncThunk(
  'supplierCoupon/createSupplierCoupon',
  async (param: { body: any }, { rejectWithValue }) => {
    try {
      const response = await SupplierCouponApi.create(param.body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneSupplierCoupon = createAsyncThunk(
  'supplierCoupon/findOneSupplierCoupon',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, option } = params;
      const response = await SupplierCouponApi.findOne(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateSupplierCoupon = createAsyncThunk(
  'supplierCoupon/updateSupplierCoupon',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await SupplierCouponApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeSupplierCoupon = createAsyncThunk(
  'supplierCoupon/removeSupplierCoupon',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await SupplierCouponApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  myList: Array<any>;
  collaboratorList: Array<any>;
  list: Array<any>;
  savedPagination: any;
  savedList: Array<any>;
}

const initialState: IState = {
  tableList: [],
  myList: [],
  collaboratorList: [],
  list: [],
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const supplierCouponSlice = createSlice({
  name: 'supplierCoupon',
  initialState,
  reducers: {
    updateSavedPaginationSupplierCoupon(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListSupplierCoupon(state, action) {
      state.savedList = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(findSupplierCouponForTableList.fulfilled, (state, action) => {
        const { data } = action.payload;

        const newData = data.map(item => {
          return {
            ...item,
            key: item.id,
            value: item.id,
          };
        });

        state.tableList = newData;
      })

      .addCase(filterSupplierCoupon.fulfilled, (state, action) => {
        const { data } = action.payload;

        const newData = data.map(item => {
          return {
            ...item,
            key: item.id,
            value: item.id,
          };
        });

        state.tableList = newData;
      });
  },
});

const { actions, reducer: supplierCouponReducer } = supplierCouponSlice;

export const {
  updateSavedPaginationSupplierCoupon,
  updateSavedListSupplierCoupon,
} = actions;

export default supplierCouponReducer;
